import marqueeImage1 from "../../Assets/AIOnDemand/marquee1.png";
import marqueeImage2 from "../../Assets/AIOnDemand/marquee2.png";
import LogosMarquee from "./LogoMarquee";
const PlugAndPlay = () => {
    return (
        <section>

            <div className="w-full h-full mb-10 lg:mb-20 mx-auto px-4 pt-8  flex flex-col justify-between items-center">
                <div className=" max-w-[1500px] mb-7 lg:mb-16 ">
                    <h2 className="text-3xl md:text-5xl lg:text-7xl  text-black font-semibold text-center flex items-start justify-center">
                        Plug & Play
                    </h2>
                    <h4 className="text-center w-[75%] mx-auto md:mx-auto  md:w-fit text-black md:text-2xl mt-6">
                        AI That Integrates. Connected to Your Tech Stack & Data.
                    </h4>
                </div>
                <div className="flex flex-col gap-5 lg:gap-10">
                    <LogosMarquee image={marqueeImage1} />
                    <LogosMarquee image={marqueeImage2} isReverse />
                </div>
            </div>
        </section>
    );
}

export default PlugAndPlay;